import React, { useState, useMemo, useContext, useEffect, useRef, useCallback } from "react";
import OrderService from "../../../services/OrderService";
import { UserContext } from "../../context/UserContext";
import OrderCard from "./components/OrderCard";
import OrderModal from "./components/OrderModal";
import './assets/scss/main.scss';
// import { useSocket } from "../../context/SocketContext";
import Notification from "../../components/Notification/Notification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faFaceFrown, faObjectGroup, faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import renameKeys from "./utils/renameKeys";
import OrderGroupingService from "../../../services/OrderGroupingService";
import Swal from "sweetalert2";
import OrderFilters from "./components/OrderFilters";
import { Oval } from "react-loader-spinner";
import OrderGroupingCard from "./components/OrderGroupingCard";
import { IconCheckbox } from "../../components/Checkbox/Checkbox";
import { usePolling } from "../../../hooks/usePolling";


const OrderManagement = (props) => {

    window.document.title = 'Acompanhamento | Motum'

    const { user, selectedStore, stores } = useContext(UserContext);

    const orderService = useMemo(() => new OrderService(), []);
    const orderGroupingService = useMemo(() => new OrderGroupingService(), []);

    const [selectedOrder, setSelectedOrder] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    // Dates
    const actualDate = new Intl.DateTimeFormat('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).format(new Date()).split('/').reverse().join('-');

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const formattedTomorrow = new Intl.DateTimeFormat('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).format(tomorrow).split('/').reverse().join('-');

    const [filters, setFilters] = useState({
        storeId: user.type === "SHOPKEEPER" ? [selectedStore._id] : stores.map((store) => store._id),
        startDate: actualDate,
        endDate: formattedTomorrow,
        deliveryCode: "",
        customerName: "",
        page: 1,
        status: "",
        groupingOnly: false
    });

    const filtersRef = useRef(filters);
    const [orders, setOrders] = useState([]);
    const [showAllStores, setShowAllStores] = useState(user.type !== "SHOPKEEPER");
    const [userSelectedStoreIds, setUserSelectedStoreIds] = useState(filters.storeId);
    const [ordersGrouping, setOrdersGrouping] = useState([]);

    const [pagination, setPagination] = useState({
        currentPage: 0,
        totalOrders: 0,
        totalPages: 1,
    })

    const [groupOrders, setGroupOrders] = useState([]);
    const [showGroupCheck, setShowGroupCheck] = useState(false);
    const [actualList, setActualList] = useState(null);

    const [returnOrders, setreturnOrders] = useState(0);
    const [pendingOrders, setPendingOrders] = useState(0);
    const [acceptOrders, setAcceptOrders] = useState(0);
    const [arrivedOrders, setArrivedOrders] = useState(0);
    const [withdrawnOrders, setWithdrawnOrders] = useState(0);
    const [deliveredOrders, setDeliveredOrders] = useState(0);
    const [canceledOrders, setCanceledOrders] = useState(0);

    function handleGroupOrder(order, event) {
        const isChecked = event.target.checked;

        // Verifica se já existe um pedido no grupo
        if (groupOrders.length > 0 && !order.orderDetails.shared) {
            const firstStoreId = groupOrders[0].store.id;

            if (order.store.id !== firstStoreId) {
                Swal.fire({
                    title: 'Lojas diferentes!',
                    text: 'Só é possível agrupar pedidos da mesma loja.',
                    icon: 'warning',
                    timer: 1500,
                    showConfirmButton: false,
                });

                event.target.checked = false;
                return;
            }
        }

        if (isChecked) {
            if (groupOrders.length === 3 && selectedStore.mode === "CLOUD") {
                Swal.fire({
                    title: 'Limite de agrupamento excedido!',
                    text: 'Não é possível agrupar mais de 3 entregas',
                    icon: 'warning',
                    timer: 1500,
                    showConfirmButton: false,
                });

                event.target.checked = false;
                return;
            }
            setGroupOrders((prevOrders) => [...prevOrders, order]);
        } else {
            setGroupOrders((prevOrders) => prevOrders.filter((o) => o._id !== order._id));
        }
    }

    function startGrouping() {
        setShowGroupCheck(true);
    }

    function stopGrouping() {
        setGroupOrders([]);
        setShowGroupCheck(false);
    }

    async function createOrdersGrouping() {
        if (groupOrders.length <= 1) {
            Swal.fire({
                title: 'Ocorreu um erro ao agrupar!',
                text: 'Não é possível agrupar menos de 2 entregas',
                icon: 'warning',
                timer: 1500,
                showConfirmButton: false,
            });
            return;
        }

        setLoading(true);
        props.setSpinner(true);
        setTimeout(async () => {
            try {
                const store = renameKeys(groupOrders[0].store);
                const response = await orderGroupingService.createOrderGrouping(store, groupOrders);
                props.setSpinner(false);
                props.setTextSpinner('');
                if (response) {
                    Swal.fire({
                        title: 'Entregas agrupadas com sucesso!',
                        icon: 'success',
                        timer: 1500,
                        showConfirmButton: false,
                    });
                } else {
                    Swal.fire({
                        title: 'Ocorreu um erro ao agrupar as entregas!',
                        icon: 'error',
                        timer: 1500,
                        showConfirmButton: false,
                    })
                }
                setLoading(false);
                stopGrouping();
                getCountByStatus();
                loadOrders(filtersRef.current);
            } catch (error) {
                stopGrouping();
                Swal.fire({
                    title: 'Ocorreu um erro ao agrupar as entregas!',
                    text: error,
                    icon: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                })
            }
        }, 2000);
    }

    const previousPage = () => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            page: filters.page - 1
        }));
    }

    const nextPage = () => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            page: filters.page + 1
        }));
    }

    const handleFilters = (query) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            startDate: query.startDate,
            endDate: query.endDate,
            deliveryCode: query.deliveryCode,
            customerName: query.customerName,
            groupingOnly: query.groupingOnly
        }));
    };

    const handleShowAllStores = (e) => {
        const isChecked = e.target.checked;
        setShowAllStores(isChecked);

        if (isChecked) {
            // Salva a seleção atual
            setUserSelectedStoreIds(filters.storeId); 
            setFilters(prev => ({ ...prev, storeId: stores.map(s => s._id), page: 1 }));
        } else {
            // Restaura a seleção
            setFilters(prev => ({ ...prev, storeId: userSelectedStoreIds, page: 1 }));
        }
    }

    function handleChangeOrders(status) {
        setFilters((prevFilters) => ({
            ...prevFilters,
            status: status
        }));
    }

    function handleShowModal(order) {
        setSelectedOrder(order);
        setIsModalOpen(order !== null);
    }

    async function groupingReadyToPickup(groupingId) {
         const result = await Swal.fire({
            title: `Deseja confirmar que o agrupamento está pronto para entrega?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#50A773',
            cancelButtonColor: '#ccc',
            confirmButtonText: 'Sim, confirmar!',
            cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
            props.setSpinner(true);
            await orderGroupingService.readyToPickup(groupingId);
            setTimeout(() => {
                props.setSpinner(false);
                setLoading(false);
            }, 1000);
        }
    }

    async function readyToPickup(orderId, deliveryCode) {
        const result = await Swal.fire({
            title: `Deseja confirmar que o pedido #${deliveryCode} está pronto para entrega?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#50A773',
            cancelButtonColor: '#ccc',
            confirmButtonText: 'Sim, confirmar!',
            cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
            props.setSpinner(true);
            await orderService.readyToPickup(orderId);
            setTimeout(() => {
                props.setSpinner(false);
                setLoading(false);
            }, 1000);
        }
    }

    async function confirmDelivery(orderId, driverId) {
        const result = await Swal.fire({
            title: 'Deseja confirmar a entrega desse pedido?',
            text: 'Essa ação é irrevesível',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#ccc',
            confirmButtonText: 'Sim, confirmar!',
            cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
            props.setSpinner(true);
            await orderService.confirmDelivery(orderId, driverId);
            setTimeout(() => {
                props.setSpinner(false);
                setLoading(false);
            }, 1000);
        }
    }

    const getCountByStatus = useCallback(async () => {
        const f = filtersRef.current;

        if (!f.storeId || f.storeId.length === 0) {
            setreturnOrders(0);
            setPendingOrders(0);
            setAcceptOrders(0);
            setArrivedOrders(0);
            setWithdrawnOrders(0);
            setDeliveredOrders(0);
            setCanceledOrders(0);
            return;
        }

        const response = await orderService.getCountStatusByStore(f.storeId, f);

        setreturnOrders(response.return);
        setPendingOrders(response.pending);
        setAcceptOrders(response.accept);
        setArrivedOrders(response.arrived);
        setWithdrawnOrders(response.withdrawn);
        setDeliveredOrders(response.delivered);
        setCanceledOrders(response.canceled);
    }, [orderService]);

    const loadOrders = useCallback(async (customFilters = null, isPolling = false) => {

        const f = customFilters || filtersRef.current;

        if (!isPolling) setLoading(true);

        const response = await orderService.getAllOrdersByStore(f.storeId, f);

        // Update only if changed
        if (JSON.stringify(response.data.orders) !== JSON.stringify(orders))
            setOrders(response.data.orders);

        if (JSON.stringify(response.data.ordersGrouping) !== JSON.stringify(ordersGrouping))
            setOrdersGrouping(response.data.ordersGrouping);

        setPagination(response.pagination);
        setActualList(f.status);

        if (!isPolling) setLoading(false);

    }, [orderService, orders, ordersGrouping]);


    usePolling(() => {
        if (!isModalOpen) {
            getCountByStatus();
            loadOrders(filtersRef.current, true);
        }
    }, 30000);

    useEffect(() => {
        filtersRef.current = filters;
        loadOrders(filters);
        getCountByStatus();
    }, [getCountByStatus, filters, loadOrders]);

    useEffect(() => {
        const initialStoreId = user.type === "SHOPKEEPER" ? [selectedStore._id] : stores.map(s => s._id);
        setFilters(prev => ({ ...prev, storeId: initialStoreId }));
    }, [selectedStore, user.type, stores]);

    // Notificações
    const [orderQueue, setOrderQueue] = useState([]);
    const [processing, setProcessing] = useState(false);
    const [notificationData, setNotificationData] = useState(null);
    const [showNotification, setShowNotification] = useState(false);
    // const socket = useSocket();

    const schedulePushNotification = (data) => {
        setNotificationData(data);
        setShowNotification(true);
        setTimeout(() => {
            setShowNotification(false);
            setOrderQueue((prevQueue) => prevQueue.slice(1));
        }, 2000);
        setProcessing(false);
    }

    useEffect(() => {
        if (orderQueue.length > 0 && !processing && !showNotification) {
            setProcessing(true);
            const orderToProcess = orderQueue[0];
            schedulePushNotification(orderToProcess);
        }
        // eslint-disable-next-line
    }, [orderQueue, processing, showNotification]);

    return (
        <div className="content-container order-management-container">
            <div className="filter-buttons-container">
                <div className="filter-box" style={{ backgroundColor: '#D4D4D4', borderColor: '#8A8F9B', borderWidth: 2 }} onClick={() => handleChangeOrders("pending")}>
                    <div className="filter-box-count">{pendingOrders}</div>
                    <div className="filter-box-text">Aguardando entregador</div>
                </div>
                <div className="filter-box" style={{ backgroundColor: '#D56631' }} onClick={() => handleChangeOrders("accept")}>
                    <div className="filter-box-count">{acceptOrders}</div>
                    <div className="filter-box-text">Entrega aceita</div>
                </div>
                <div className="filter-box" style={{ backgroundColor: '#DEB543' }} onClick={() => handleChangeOrders("arrived")}>
                    <div className="filter-box-count">{arrivedOrders}</div>
                    <div className="filter-box-text">Entregador chegou</div>
                </div>
                <div className="filter-box" style={{ backgroundColor: '#FFF' }} onClick={() => handleChangeOrders("withdrawn")}>
                    <div className="filter-box-count">{withdrawnOrders}</div>
                    <div className="filter-box-text">Saiu para entrega</div>
                </div>
                <div className="filter-box" style={{ backgroundColor: '#B3E0FF' }} onClick={() => handleChangeOrders("return")}>
                    <div className="filter-box-count">{returnOrders}</div>
                    <div className="filter-box-text">Devoluções</div>
                </div>
                <div className="filter-box" style={{ backgroundColor: '#8EDDA6' }} onClick={() => handleChangeOrders("delivered")}>
                    <div className="filter-box-count">{deliveredOrders}</div>
                    <div className="filter-box-text">Concluídos</div>
                </div>
                <div className="filter-box" style={{ backgroundColor: '#C47D7B' }} onClick={() => handleChangeOrders("canceled")}>
                    <div className="filter-box-count">{canceledOrders}</div>
                    <div className="filter-box-text">Canceladas</div>
                </div>
            </div>
            <div className="checkbox-container" >
                <IconCheckbox
                    label="Ver todas as lojas"
                    checked={showAllStores}
                    onChange={handleShowAllStores}
                />
            </div>
            <div className="actions-buttons">
                <OrderFilters filters={filters} setFilters={setFilters} setPagination={setPagination} onApplyFilters={handleFilters} showAllStores={showAllStores} />
                {(actualList !== "withdrawn" && actualList !== "delivered" && actualList !== "canceled") &&
                    <div className="group-buttons">
                        {!showGroupCheck && <button type="button" className="btn-primary" onClick={startGrouping}><FontAwesomeIcon icon={faObjectGroup} title="Agrupamento" style={{ marginRight: 10, height: 15, color: '#fff' }} />Agrupar Pedidos</button>}
                        {showGroupCheck && <button type="button" className="btn-primary" onClick={createOrdersGrouping}><FontAwesomeIcon icon={faPlus} title="Agrupamento" style={{ marginRight: 10, height: 15, color: '#fff' }} />Criar Agrupamento</button>}
                        {showGroupCheck && <button type="button" className="btn-danger" onClick={stopGrouping}><FontAwesomeIcon icon={faXmark} title="Agrupamento" style={{ height: 15, color: '#fff' }} /></button>}
                    </div>
                }
            </div>
            <div className="management-list">
                {orders.length > 0 && orders.map((order) => <OrderCard key={order._id} order={order} handleShowModal={handleShowModal} handleGroupOrder={handleGroupOrder} showGroupCheck={showGroupCheck} readyToPickup={readyToPickup} />)}
                {ordersGrouping.length > 0 && ordersGrouping.map((grouping) =>
                    <OrderGroupingCard key={grouping._id} grouping={grouping} handleShowModal={handleShowModal} handleGroupOrder={handleGroupOrder} groupingReadyToPickup={groupingReadyToPickup} />
                )}

                {(orders.length === 0 && ordersGrouping.length === 0) &&
                    <div className="no-orders">
                        {loading ? (
                            <Oval
                                visible={loading}
                                height="50"
                                width="50"
                                color="#0d6efd"
                                secondaryColor="#0d6efd"
                                radius="1"
                            />
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faFaceFrown} />
                                <p>Que pena!</p>
                                <p>Parece que você ainda tem pedidos no momento!</p>
                            </>
                        )}
                    </div>
                }
            </div>
            <div className="pagination-container">
                {filters.page > 1 && <button type="button" onClick={previousPage}><FontAwesomeIcon icon={faChevronLeft} /></button>}
                {pagination.totalPages > 1 && <span>{filters.page}</span>}
                {filters.page < pagination.totalPages && <button type="button" onClick={nextPage}><FontAwesomeIcon icon={faChevronRight} /></button>}
            </div>
            {isModalOpen && <OrderModal confirmDelivery={confirmDelivery} order={selectedOrder} setSpinner={props.setSpinner} handleShowModal={handleShowModal} />}
            {showNotification && <Notification notificationData={notificationData} />}
        </div>
    );
}

export default OrderManagement;

// region : Code not used

// useEffect(() => {
    //     const handleUpdateOrder = (data) => {
    //         getCountByStatus();
    //     }

    //     const handleLoading = () => {
    //         getCountByStatus();
    //     }

    //     socket.on('CANCEL_ORDER', handleUpdateOrder);
    //     socket.on('DELIVERED_ORDER', handleUpdateOrder);
    //     socket.on('WITHDRAWN_ORDER', handleUpdateOrder);
    //     socket.on('ARRIVED_ORDER', handleUpdateOrder);
    //     socket.on('ACCEPT_ORDER', handleUpdateOrder);
    //     socket.on('NEW_ORDER', handleUpdateOrder);
    //     socket.on('LOADING', handleLoading);

    //     return () => {
    //         socket.off('CANCEL_ORDER', handleUpdateOrder);
    //         socket.off('DELIVERED_ORDER', handleUpdateOrder);
    //         socket.off('WITHDRAWN_ORDER', handleUpdateOrder);
    //         socket.off('ARRIVED_ORDER', handleUpdateOrder);
    //         socket.off('ACCEPT_ORDER', handleUpdateOrder);
    //         socket.off('NEW_ORDER', handleUpdateOrder);
    //         socket.off('LOADING', handleLoading);
    //     };
    //     // eslint-disable-next-line
    // }, [socket]);

// endregion
